import { useState } from 'react'
import { isAxiosError } from 'axios'
import { Button, Group, Text } from '@mantine/core'
import { IconSend } from '@tabler/icons-react'

import { encaminharAnalise } from '@/api/robo'

/**
 * "Pedir a quem pode" (spec 2026-09-30-robo-agente-pessoal §4, P3). Aparece na resposta
 * em que o robô não pôde investigar produção pelo perfil do dono: o pedido vai a quem
 * tem a permissão naquele ambiente, e o primeiro que pegar fica com ele.
 */
const MOTIVO: Record<string, string> = {
  ninguem_pode_analisar: 'Ninguém além de você investiga produção neste ambiente.',
}

const pessoas = (n: number) => (n === 1 ? '1 pessoa' : `${n} pessoas`)

export function OfertaDeEncaminhamento({ cid, messageId, enviado }: {
  cid: number; messageId: number; enviado?: { destinatarios: number }
}) {
  const [feito, setFeito] = useState<number | null>(enviado?.destinatarios ?? null)
  // 409 `ja_encaminhado`: outra aba (ou um clique duplo) já enviou — não é erro.
  const [jaEnviado, setJaEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  if (jaEnviado) return <Text size="sm" c="dimmed" mt="xs">Este pedido já foi enviado.</Text>
  if (feito !== null) return <Text size="sm" c="dimmed" mt="xs">Pedido enviado a {pessoas(feito)}.</Text>

  const pedir = async () => {
    setEnviando(true)
    setErro(null)
    try {
      setFeito((await encaminharAnalise(cid, messageId)).destinatarios)
    } catch (e) {
      const motivo = isAxiosError(e) ? String(e.response?.data?.detail ?? '') : ''
      if (motivo === 'ja_encaminhado') {
        setJaEnviado(true)
        return
      }
      setErro(MOTIVO[motivo] ?? 'Não consegui enviar o pedido. Tente de novo.')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <Group gap="sm" mt="xs">
      <Button size="xs" variant="light" leftSection={<IconSend size={16} />} loading={enviando} onClick={pedir}>
        Pedir a quem pode
      </Button>
      {erro && <Text size="sm" c="red">{erro}</Text>}
    </Group>
  )
}
